<template>
    <div id="page-container" class="sidebar-l side-scroll header-navbar-fixed">
        <!-- Header -->
        <header id="header-navbar" >
            <div class="content-mini content-mini-full content-boxed">

                <!-- Admin Header Navigation Right -->
                <ul class="nav-header nav-pills pull-right hidden-xs" :class="{'hidden-sm':isAdmin}">
                    <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('home') }">
                        <router-link to="/">
                            <i class="fa fa-home"></i>
                            Dashboard
                        </router-link>
                    </li>
                    <li v-bind:class="{ active: isActiveRoute('inspections') }">
                        <router-link to="/inspections">
                            <i class="fa fa-file"></i>
                            Inspections
                        </router-link>
                    </li>

                    <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('foresters') }" >
                        <router-link to="/foresters">
                            <i class="fa fa-tree"></i>
                            Foresters
                        </router-link>
                    </li>

                    <li v-bind:class="{ active: isActiveRoute('profile') }" >
                        <router-link to="/profile">
                            <i class="fa fa-user"></i>
                            Profile
                        </router-link>
                    </li>

                    <li>
                        <a href="" v-on:click.prevent="logout">
                            <i class="fa fa-sign-out"></i>
                            Logout
                        </a>
                    </li>

                    <li class="hidden-sm" v-bind:class="{ active: isActiveRoute('help') }">
                        <router-link to="/help" >
                            <i class="fa fa-question-circle"></i>
                            Help
                        </router-link>
                    </li>


                    <li class="visible-sm" v-bind:class="{ active: isActiveRoute('help') }">
                        <router-link to="/help" >
                            <i class="fa fa-lg fa-question-circle"></i>
                        </router-link>
                    </li>

                </ul>

                <!-- Admin Header Navigation Right -->
                <ul v-if="isAdmin" class="nav-header nav-pills pull-right visible-sm">
                    <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('home') }">
                        <router-link to="/">
                            <i class="fa fa-lg fa-home"></i>
                        </router-link>
                    </li>
                    <li v-bind:class="{ active: isActiveRoute('inspections') }">
                        <router-link to="/inspections">
                            <i class="fa fa-lg fa-file"></i>
                        </router-link>
                    </li>

                    <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('foresters') }" >
                        <router-link to="/foresters">
                            <i class="fa fa-lg fa-tree"></i>
                        </router-link>
                    </li>

                    <li v-bind:class="{ active: isActiveRoute('profile') }" >
                        <router-link to="/profile">
                            <i class="fa fa-lg fa-user"></i>
                        </router-link>
                    </li>

                    <li>
                        <a href="" v-on:click.prevent="logout">
                            <i class="fa fa-lg fa-sign-out"></i>
                        </a>
                    </li>

                    <li v-bind:class="{ active: isActiveRoute('help') }">
                        <router-link to="/help" >
                            <i class="fa fa-lg fa-question-circle"></i>
                        </router-link>
                    </li>

                </ul>

                <!-- END Header Navigation Right -->

                <!-- <button v-if="isInspector" type="button" class="btn btn-sm btn-danger navbar-btn hidden-xs" style="margin: 2px 0 0 0; border-radius: 50%;" @click="newInspection">
                    <i class="fa fa-question"></i>
                </button>

                <button v-if="isInspector" type="button" class="btn btn-sm btn-danger navbar-btn pull-right visible-xs" style="margin: 2px 0 0 0; border-radius: 50%;" @click="newInspection">
                    <i class="fa fa-question
                    "></i>
                </button> -->


                <button v-if="isInspector" type="button" class="btn btn-sm btn-success navbar-btn hidden-xs" style="margin: 2px 0 0 0;" @click="newInspection">
                    <i class="fa fa-plus push-5-r"></i> New Inspection
                </button>

                <button v-if="isInspector" type="button" class="btn btn-sm btn-success navbar-btn pull-right visible-xs" style="margin: 2px 0 0 0;" @click="newInspection">
                    <i class="fa fa-plus push-5-r"></i> New Inspection
                </button>


                <!-- Header Navigation Left -->
                <ul class="nav-header nav-pills pull-left">
                    <li class="header-content">
                        <router-link to="/">
                            <span class="text-logo">CertPilot</span>
                            <span v-if="isAdmin">&nbsp;&nbsp;</span>
                            <span v-show="isLeadingAdmin" class="label label-success text-logo-label">ADMINISTRATOR</span>
                            <!-- <span v-show="isLeadingInspector" class="label label-success text-logo-label">FORESTER</span> -->
                        </router-link>
                    </li>
                </ul>
                <!-- END Header Navigation Left -->
            </div>
        </header>
        <!-- END Header -->

        <!-- Main Container -->
        <main id="main-container">
            <!-- Sub Header -->
            <div class="bg-gray-lighter visible-xs">
                <div class="content-mini content-boxed">
                    <button class="btn btn-block btn-default visible-xs push" data-toggle="collapse" data-target="#sub-header-nav">
                        <i class="fa fa-navicon push-5-r"></i>Menu
                    </button>
                </div>
            </div>
            <div class="collapse navbar-collapse remove-padding" id="sub-header-nav">
                <div class="content-mini content-boxed visible-xs">
                    <ul class="nav nav-pills nav-sub-header push">
                        <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('home') }">
                            <router-link to="/">
                                <i class="fa fa-home push-5-r"></i>
                                Dashboard
                            </router-link>
                        </li>


                        <li v-bind:class="{ active: isActiveRoute('inspections') }">
                            <router-link to="/inspections">
                                <i class="fa fa-file push-5-r"></i>
                                Inspections
                            </router-link>
                        </li>

                        <li v-show="isAdmin" v-bind:class="{ active: isActiveRoute('foresters') }" >
                            <router-link to="/foresters">
                                <i class="fa fa-tree push-5-r"></i>
                                Foresters
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/profile">
                                <i class="fa fa-user push-5-r"></i>
                                Profile
                            </router-link>
                        </li>
                        <li>
                            <a href="" v-on:click.prevent="logout">
                                <i class="fa fa-sign-out push-5-r"></i>
                                Logout
                            </a>
                        </li>
                        <li v-bind:class="{ active: isActiveRoute('help') }">
                            <router-link to="/help">
                                <i class="fa fa-question-circle push-5-r"></i>
                                Help
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- END Sub Header -->

            <!-- Page Content -->
            <div class="content content-boxed">
                <slot></slot>
            </div>
            <!-- END Page Content -->
        </main>
        <!-- END Main Container -->

        <!-- Footer -->
        <footer id="page-footer" class="bg-body font-s12">
            <div class="content-mini content-mini-full content-boxed clearfix push-15">
                <div class="pull-left">
                    <a class="font-w600" href="http://www.woodscamp.com" target="_blank">Woodscamp Technologies Inc.</a> &copy; <span class="js-year-copy">{{ new Date().getFullYear() }}</span>
                </div>
            </div>
        </footer>
        <!-- END Footer -->

        <!-- Busy overlay -->
        <div id="busy" class="hidden"></div>
        <!-- End Busy overlay -->
    </div>
</template>

<script>
import pdfform from '../../assets/js/pdf/pdfform.js';

    import roleMixin from '../../mixins/role-mixins.js';
    import inspectionApiMixin from '../../mixins/inspections-api-mixin.js'

    export default {
        mixins: [ roleMixin, inspectionApiMixin ],
        methods: {
            isActiveRoute (name) {
                return this.$route.name.startsWith(name);
            },
            logout () {
                this.$store.dispatch('auth/logout');
                this.$router.push('login');
            },
            newInspection () {
                this.createInspection().then((response) => {
                    this.$router.push('/inspections/' + response.data.id);
                });
            },
        }
    };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// default.vue?7fe81106